import { defineAction } from '~/prix'
import { z } from 'zod'
import residenceDocumentUpdateAction from './residenceDocumentUpdate.action.json' with { type: 'json' }
import { residenceDocumentUpdateInputObject } from '../residenceDocumentObject'

const residenceDocumentUpdateDefinition = defineAction({
  ...residenceDocumentUpdateAction,

  input: residenceDocumentUpdateInputObject,
  output: z.object({}),
})

export default residenceDocumentUpdateDefinition
